import { TextInputProps, ViewStyle } from "react-native";
import styled from "styled-components/native";
import {
  borderRadius,
  borderWidth,
  font,
  spacing,
  text,
  wpdColor,
} from "../theme";
import { convertObjectToStyle } from "../../utils";

export interface CustomTextInput extends TextInputProps, ViewStyle {
  borderStyle?: string;
  outline?: string;
  type?: string;
}

export default styled.TextInput<CustomTextInput>`
  font-size: ${text.extraSmall.size};
  font-family: ${font.defaultRegular};
  padding: ${spacing.medium} ${spacing.medium};
  margin-bottom: ${spacing.medium};
  border-radius: ${borderRadius.small};
  border-width: ${borderWidth.small};
  border-color: ${wpdColor.backgroundDark};
  background-color: ${({ editable }: CustomTextInput) =>
    editable === false ? wpdColor.backgroundDark : "transparent"};
  ${(props: CustomTextInput) =>
    convertObjectToStyle(props, [
      "borderWidth",
      "marginBottom",
      "outline",
      "width",
    ])};
`;
